import * as React from "react";
import { addYears } from "../../../../../../react-core/utils/date";
import { CappedPensionArrangementsFlexiConversionInstruction } from "../../../../../../Wrap/Models/Domains/Drawdown/CappedPensionArrangementsFlexiConversionInstruction";
import { AccountConversion } from "../../../../../../Wrap/Models/Models/Processes/Drawdown/AccountConversion";
import { ConvertCappedToFlexiModel } from "../../../../../../Wrap/Models/Models/Processes/Drawdown/ConvertCappedToFlexiModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { AccountsConversionTable } from "../../Common/ConvertCappedToFlexi/AccountsConversionTable";
import { FlexiIncomeReview } from "../../Common/ConvertCappedToFlexi/FlexiIncomeReview";
import { ImportantInformation } from "../../Common/ConvertCappedToFlexi/ImportantInformation";
import { IncomeReview } from "../../Common/SIPP/DrawdownDetails/IncomeReview";
import { convertToFlexiStepperName } from "../Resource/Content";

interface ISelectArrangementProps extends IProcessComponentProps {}

interface ISelectArrangementState {}

export class SelectArrangement extends ProcessComponent<ISelectArrangementProps, ISelectArrangementState> {
    constructor(props: any) {
        super(props);
        this.state = { showImportantInformationPopUp: false };
    }

    isValid() {
        const instruction: CappedPensionArrangementsFlexiConversionInstruction = this.props.data.instruction;
        const selectedArrangements: number[] = instruction.CappedPensionArrangementIds;
        if (selectedArrangements.length == 0) {
            this.props.showErrorMsgPopUp(["Please select an arrangement to continue."], true);
        }
        return super.isValid() && selectedArrangements.length > 0;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                <h2 className="mb-18">
                    <span>{convertToFlexiStepperName.selectArrangement}</span>
                </h2>
                <ImportantInformation data={data} onChange={() => {}} onRef={(ref) => this.appendChild(ref)} />
                <AccountsConversionTable
                    data={data}
                    onChange={(v) => {
                        this.onSelectionChange(v);
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    isReviewStep={false}
                    isReview={this.props.isReview}
                />
                {/* <IncomeReview
                    data={
                        this.props.data?.Contribution == null
                            ? {
                                  DrawdownIncomeReviewDetails: {
                                      IncomeReviewDate: addYears(new Date(), 1),
                                      IncomeReviewFrequency: 12,
                                  },
                              }
                            : this.props.data?.Contribution
                    }
                    onChange={(v) => this.onDataChange(onChange, v, data, "Contribution")}
                    onRef={(ref) => this.appendChild(ref)}
                /> */}
            </>
        );
    }

    private onSelectionChange(selectedIds: number[]) {
        const { data } = this.props;
        data.instruction.CappedPensionArrangementIds = selectedIds;
        this.props.onChange({
            instruction: data.instruction,
        });
    }
}
